import { assign, get } from 'lodash-es'
import mapboxgl from 'mapbox-gl'
import { useEffect, useState, useMemo } from 'react'

export default function usePopup({ lng, lat, ops }) {
  const [popup, setPopup] = useState()
  const box = useMemo(() => document.createElement('div'), [])

  useEffect(() => {
    if (popup) {
      const offset = get(ops, 'offset')
      popup.setLngLat([lng, lat])
      offset && popup.setOffset(offset)
    } else {
      const popup = createPopup(lng, lat, box, ops)
      setPopup(popup)
    }
  }, [lng, lat, box, ops, popup])

  return { popup, box }
}

export function createPopup(lng, lat, node, ops) {
  if (!lng || !lat) return null

  const popup = new mapboxgl.Popup(assign({ focusAfterOpen: false, closeButton: false }, ops))
  if (node) popup.setDOMContent(node)
  return popup
}